<template>
  <div>
    <label v-if="label" v-bind="labelBindings">{{ label }}</label>
    <select v-bind="inputBindings" v-on="inputEvents">
      <option v-for="option in options" :value="option.value" :key="option.value">
        {{ option.label || option.value }}
      </option>
    </select>
    <p v-if="invalid" class="text-danger">{{ errorMessage }}</p>
  </div>
</template>
<script>
import BaseInput from './BaseInput'

export default {
  extends: BaseInput,

  props: {
    options: {
      type: Array,
      required: true
    }
  },

  computed: {
    inputBindings () {
      return {
        id: this.id,
        value: this.value,
        'class': 'form-select mb-2'
      }
    }
  }
}
</script>
